import React from "react";

import cn from "classnames";
import { defineMessages, useIntl } from "react-intl";

import styles from "./Pager.module.scss";

const messages = defineMessages({
  pagerCounter: {
    id: "announcements.pager.counter",
    defaultMessage: "{current} of {total}",
    description: "Position of the current announcement, read by screen readers",
  },
});

interface PagerProps {
  current: number;
  total: number;
}

const Pager = ({ current, total }: PagerProps) => {
  const intl = useIntl();

  if (total <= 1) {
    return null;
  }

  return (
    <div
      aria-label={intl.formatMessage(messages.pagerCounter, {
        current: current + 1,
        total,
      })}
      className={styles.dots}
      role="img"
    >
      {Array.from({ length: total }, (_, index) => (
        <span
          className={cn(styles.dot, {
            [styles.active]: index === current,
            [styles.passed]: index < current,
          })}
          key={index}
        />
      ))}
    </div>
  );
};

export default Pager;
